export interface CalendarI {
  id: number | string;
  name: string;
  color: string;
  userId: number;
  app: string;
  created: number;
  updated: number;
}

// Name: Festivos estados unidos
// app: festivos-estados-unidos

export interface CalendarStateI {
  calendars: CalendarI[];
  calendar: CalendarI;
  hiddenCalendarIds: Array<number | string>;
}

const HIDDEN_CALENDARS_STORAGE_KEY = 'hiddenCalendarIds';

function getInitialHiddenCalendarIds(): Array<number | string> {
  try {
    if (typeof window !== 'undefined' && localStorage) {
      const stored = localStorage.getItem(HIDDEN_CALENDARS_STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    }
  } catch (e) {
    console.error('Error loading hidden calendars from localStorage', e);
  }
  return [];
}

export const state: CalendarStateI = {
  calendars: [],
  hiddenCalendarIds: getInitialHiddenCalendarIds(),
  calendar: {
    id: 0,
    name: '',
    color: '',
    userId: 0,
    app: '',
    created: 0,
    updated: 0,
  },
};

export function saveHiddenCalendarIds(ids: Array<number | string>): void {
  try {
    if (typeof window !== 'undefined' && localStorage) {
      localStorage.setItem(HIDDEN_CALENDARS_STORAGE_KEY, JSON.stringify(ids));
    }
  } catch (e) {
    console.error('Error saving hidden calendars to localStorage', e);
  }
}
